import config from 'uplisting-frontend/config/environment';

const BASE_URL = `https://www.airbnb.com/oauth2/auth?client_id=${config.airbnbOfficial.clientId}`;

export const AIRBNB_CONNECT_LINK = `${BASE_URL}&scope=${config.airbnbOfficial.readOnlyScopes}&redirect_uri=${config.airbnbOfficial.redirectUri}`;
export const AIRBNB_UPGRADE_LINK = `${BASE_URL}&scope=${config.airbnbOfficial.fullAccessScopes}&redirect_uri=${config.airbnbOfficial.redirectUpgradeUri}`;
